"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import '../../DataBuilderUI/FieldControlPanel/index.mjs';
import '../../DataBuilderUI/ActionBar.mjs';
import { Cell } from '../../DataBuilderUI/Cell.mjs';
import { NestedLevel } from '../../DataBuilderUI/NestedLevel.mjs';
import { Row } from '../../DataBuilderUI/Row.mjs';
import '../../DataBuilderUI/Title.mjs';
import { DataBuilderFieldProvider } from '../field-context.mjs';
import { FieldDelete } from '../FieldDelete.mjs';
import { useDataBuilderComponents } from '../use-data-builder-components.mjs';
import { DataBuilderFieldControlPanel } from './FieldControlPanel/index.mjs';

function DataBuilderFormNestedArrayItems({
  field,
  onChange
}) {
  const allowToAdd = !field.schema?.maxItems || (field?.subFields ?? [])?.length < field.schema.maxItems;
  function handleAddItem() {
    onChange([...field.value ?? [], null]);
  }
  if (Array.isArray(field.value)) {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(ArrayItems, { field, onChange }),
      allowToAdd && /* @__PURE__ */ jsx(DataBuilderFieldControlPanel, { field, onAdd: handleAddItem })
    ] });
  } else if (field.value) {
    return null;
  } else {
    return /* @__PURE__ */ jsx(Fragment, { children: allowToAdd && /* @__PURE__ */ jsx(DataBuilderFieldControlPanel, { field, onAdd: handleAddItem }) });
  }
}
function ArrayItems({ field, onChange }) {
  function handleItemChange(index, value) {
    const newValue = [...field.value || []];
    newValue[index] = value;
    onChange(newValue);
  }
  function handleDeleteItem(index) {
    const newValue = [...field.value || []];
    newValue.splice(index, 1);
    onChange(newValue.length > 0 ? newValue : void 0);
  }
  return /* @__PURE__ */ jsx(Fragment, { children: field.subFields.map((itemField, index) => {
    return /* @__PURE__ */ jsx(
      DataComposerFieldArrayItem,
      {
        field: itemField,
        onChange: (value) => handleItemChange(index, value),
        onDelete: () => handleDeleteItem(index)
      },
      index
    );
  }) });
}
function DataComposerFieldArrayItem({ field, onChange, onDelete = void 0 }) {
  const { Nested, FieldValue } = useDataBuilderComponents();
  function handleChange(value) {
    onChange?.(value);
  }
  return /* @__PURE__ */ jsxs(DataBuilderFieldProvider, { field, children: [
    /* @__PURE__ */ jsx(NestedLevel, { level: field.level, children: /* @__PURE__ */ jsxs(Row, { children: [
      /* @__PURE__ */ jsx(Cell, { type: "icon", icon: SvgIconType.Array }),
      /* @__PURE__ */ jsx(Cell, { type: "combobox", span: "grow", className: "ph-mask", children: /* @__PURE__ */ jsx(FieldValue, { field, onChange: handleChange }) }),
      onDelete && /* @__PURE__ */ jsx(FieldDelete, { onClick: onDelete })
    ] }) }),
    /* @__PURE__ */ jsx(Nested, { field, onChange: handleChange })
  ] });
}

export { DataBuilderFormNestedArrayItems as default };
